module.exports = __webpack_public_path__ + "static/media/holyfamily.4fe84565.webp";